export default __webpack_public_path__ + "static/puzzlingcompany-3d19c4342ae637f703ef1a42140c8262.png";